import { render, staticRenderFns } from "./DisplayStatus.vue?vue&type=template&id=311fbbfa&scoped=true"
import script from "./DisplayStatus.vue?vue&type=script&lang=js"
export * from "./DisplayStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311fbbfa",
  null
  
)

export default component.exports